export default "__VITE_ASSET__Btgprt4z__"